import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fd69fed0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "go1-icon"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "go1-inline-flex" }
const _hoisted_4 = { class: "go1-icon" }
const _hoisted_5 = {
  key: 0,
  class: "cruz"
}

interface IconDesca {
  icon: string | object;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'IconDescabrazo',
  props: {
    icon: null
  },
  setup(__props: any) {

const props = __props as {
  icon: string | object;
};

const isAnObject = (): boolean => {
  return props.icon instanceof Object;
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!isAnObject())
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          _createElementVNode("i", {
            class: _normalizeClass(["go1-align-self-center go1-text-700", 'fas ' + props.icon])
          }, null, 2)
        ]))
      : _createCommentVNode("", true),
    (isAnObject())
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.icon, (ico, index) => {
            return (_openBlock(), _createElementBlock("span", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, [
                _createElementVNode("i", {
                  class: _normalizeClass(["go1-align-self-center text-700", 'fas ' + ico])
                }, null, 2)
              ]),
              (index == 'Hotel')
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, " + "))
                : _createCommentVNode("", true)
            ]))
          }), 256))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})